const ERROR_CODES = {
  Third: {
    UNAUTHORIZED_ERROR: "customer-008"
  },
  Shared: {
    UNKNOWN_ERROR: 'error-000',
    UNAUTHORIZED_ERROR: 'error-001',
    REQUEST_CANCELED: 'error-002',
    REQUEST_TIMEOUT: 'error-003',
    CONNECTION_RESET: 'error-004',
    CONNECTION_REFUSED: 'error-005',
    NETWORK_ERROR: 'error-006'
  },
  Retail: {
    // TODO: Add retail error codes
  },
  Flights: {
    NO_ITINERARY_FOUND_FOR_SEARCH: 'flights-001',
    ERROR_GETTING_PRICES: 'flights-002',
    DATE_NOT_ALLOWED: 'flights-003',
    SEARCH_SESSION_EXPIRED: 'SEARCH-SESSION-EXPIRED',
    CHECK_PASSENGER_DATA: 'CHECK-PASSENGER-DATA--000',
    ERROR_INVALID_PARAMETERS: 'ERROR-INVALID-PARAMETERS--000',
    ITINERARY_RETURNS_BAD_STATUS: 'ITINERARY-RETURNS-BAD-STATUS--000',
    SEND_EMAIL_ERROR: 'SEND-EMAIL-ERROR--000',
    EXPIRED_OFFER: 'EXPIRED-OFFER',
    // Any flow error of purchase including no controlled flight fare error
    ERROR_ON_PROCESSING_FLOW: 'ERROR-ON-PROCESSING-FLOW',
    // Duplex purchase failure
    ERROR_FLOW_001: 'ERROR-FLOW-001',
    // Churning purchase failure
    ERROR_FLOW_002: 'ERROR-FLOW-002',
    // Timeout booking response
    ERROR_FLOW_003: 'ERROR-FLOW-003',
    // not controlled error on booking (undefined response)
    ERROR_FLOW_004: 'ERROR-FLOW-004',
    // Izipay controlled pause on payment
    PENDING_PAYMENT: 'PENDING_PAYMENT'
  },
  Customers: {
    CUSTOMERS_AUTH_SERVICES_ERROR: 'customers-login-000'
  },
  Hotels: {
    INVALID_SEARCH_PARAMETERS: 'external_provider-001'
  },
  GuestCustomers: {
    DATA_ALREADY_EXISTS: 'customer-000'
  }
};
export default ERROR_CODES;